import OrderDetailsHistoryEntryChangeRideInternalEvent from "./order-details-history-change-ride-event";
import OrderDetailsHistoryEventType from "./order-details-history-event-type";
import OrderDetailsHandlingLogEntryEvent from "./order-details-handling-log-entry-event";
import BillingModel from "../../../../../../common/types/billing-model";

export type OrderDetailsHistoryEntryBindPassengerEvent = {
  type: OrderDetailsHistoryEventType.BIND_PASSENGER;
};

export type OrderDetailsHistoryEntryCancelOrderEvent = {
  type: OrderDetailsHistoryEventType.CANCEL_ORDER;
};

export type OrderDetailsHistoryEntryChangeRideEvent = {
  type: OrderDetailsHistoryEventType.CHANGE_RIDE;
  events: OrderDetailsHistoryEntryChangeRideInternalEvent[];
};

export type OrderDetailsHistoryEntryChangeTargetTaxiEvent = {
  type: OrderDetailsHistoryEventType.CHANGE_TARGET_TAXI;
};

export type OrderDetailsHistoryEntryDealerApprovalEvent = {
  type: OrderDetailsHistoryEventType.DEALER_APPROVAL;
  approvingDealerUuid: string;
};

export type OrderDetailsHistoryEntryDispatchApprovalEvent = {
  type: OrderDetailsHistoryEventType.DISPATCH_APPROVAL;
  approvingDispatcherUuid: string;
};

export type OrderDetailsHistoryEntryExternalIdUpdateEvent = {
  type: OrderDetailsHistoryEventType.EXTERNAL_ID_UPDATE;
  newCargoExternalOrderId: string;
};

export type OrderDetailsHistoryEntryInitializeEventRouteWaypoint = {
  stageNo: number;
  addressDisplayName: string;
  haltingTime: number;
  plannedDate: Date | null;
};

export type OrderDetailsHistoryEntryInitializeEvent = {
  type: OrderDetailsHistoryEventType.INITIALIZE;
  cargoExternalOrderId: string | null;
  contractModel: BillingModel | null;
  taxiCorporationName: string | null;
  route: OrderDetailsHistoryEntryInitializeEventRouteWaypoint[];
};

export type OrderDetailsHistoryEntryMergeOrdersEvent = {
  type: OrderDetailsHistoryEventType.MERGE_ORDERS;
};

export type OrderDetailsHistoryEntryOperationalApprovalEvent = {
  type: OrderDetailsHistoryEventType.OPERATIONAL_APPROVAL;
  operatorUuid: string;
};

export type OrderDetailsHistoryEntryRequestCancelOrderEvent = {
  type: OrderDetailsHistoryEventType.REQUEST_CANCEL_ORDER;
};

export type OrderDetailsHistoryEventRevertCancelOrderRequestEvent = {
  type: OrderDetailsHistoryEventType.REVERT_CANCEL_ORDER_REQUEST;
};

export type OrderDetailsHistoryEntryShuffleMergeEvent = {
  type: OrderDetailsHistoryEventType.SHUFFLE_MERGE;
  targetInternalOrderId: string;
  sourceInternalOrderIds: string[];
};

export enum OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export type OrderDetailsHistoryEntryChangeApprovalStatusEvent = {
  type: OrderDetailsHistoryEventType.CHANGE_APPROVAL_STATUS;
  approvalStatus: OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus;
};

type OrderDetailsHistoryEntryEvent =
  | OrderDetailsHistoryEntryBindPassengerEvent
  | OrderDetailsHistoryEntryCancelOrderEvent
  | OrderDetailsHistoryEntryChangeRideEvent
  | OrderDetailsHistoryEntryChangeTargetTaxiEvent
  | OrderDetailsHistoryEntryDealerApprovalEvent
  | OrderDetailsHistoryEntryDispatchApprovalEvent
  | OrderDetailsHistoryEntryExternalIdUpdateEvent
  | OrderDetailsHistoryEntryInitializeEvent
  | OrderDetailsHistoryEntryMergeOrdersEvent
  | OrderDetailsHistoryEntryOperationalApprovalEvent
  | OrderDetailsHistoryEntryRequestCancelOrderEvent
  | OrderDetailsHistoryEventRevertCancelOrderRequestEvent
  | OrderDetailsHistoryEntryShuffleMergeEvent
  | OrderDetailsHandlingLogEntryEvent
  | OrderDetailsHistoryEntryChangeApprovalStatusEvent
  | undefined;

export default OrderDetailsHistoryEntryEvent;
